export const inArray = (state) => Object.values(state.list);
export const byId = (state) => (id) => state.list[id];
export const byUuid = (state, getters) => (uuid) => getters.inArray.find((val) => val.uuid == uuid);
export const count = (state, getters) => getters.inArray.length;
export const inGroupsArray = (state) => Object.values(state.groups);
